<template>
    <img
        v-if="!isMinimized"
        alt="Logo Image"
        :src="logo"
        loading="lazy" />
    <LogoSmall
        v-else
        class="gst-logo-small" />
</template>

<script>
import { defineAsyncComponent } from 'vue';

export default {
    components: {
        LogoSmall: defineAsyncComponent(() => import('@/assets/LogoSmall.vue')),
    },
    props: {
        isMinimized: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        logo() {
            return require('@assets/logo.png');
        },
    },
};
</script>
